import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import { Flex } from "components/common/$styles";
import styled, { FlattenSimpleInterpolation } from "styled-components";

interface ChakraModalProps {
  content: React.ReactNode;
  footer?: React.ReactNode;
  actions?: React.ReactNode;
  styles?: FlattenSimpleInterpolation;
  title?: string;
  titleSlot?: React.ReactNode;
  animation?: string;
  background?: string;
  showClose?: boolean;
  isOpen: boolean;
  size?: string;
  maxWidth?: number;
  bodyStyle?: FlattenSimpleInterpolation;
  onClose: () => void;
  isOverlay?: boolean;
  closeOnOverlayClick?: boolean;
}

const hideScrollbarCss = `

::-webkit-scrollbar {
  display: none;
}

body {
  scrollbar-width: none;
}`;

const modalHeaderStyles = `
color: #d2eaff;
box-sizing: border-box;
font-size: 18px;
font-style: italic;
font-weight: 800;
letter-spacing: 0.02em;
text-align:center;

line-height: 21px;
text-transform: uppercase;
`;

const WrewardsModal: React.FC<ChakraModalProps> = ({
  content,
  footer,
  title,
  titleSlot,
  size = "lg",
  styles,
  showClose = true,
  actions,
  isOpen,
  background = "#131925",
  animation,
  onClose,
  bodyStyle,
  isOverlay = true,
  closeOnOverlayClick = false,

  ...props
}) => {
  const dynamicStyles = `
  ${hideScrollbarCss}
  ${styles}
  ${showClose ? "padding-top: 0px;" : ""}
`;
  return (
    <>
      <Modal
        autoFocus={false}
        size={size}
        closeOnOverlayClick={closeOnOverlayClick}
        isCentered
        isOpen={isOpen}
        onClose={onClose}
      >
        {isOverlay ? <ModalOverlay /> : <></>}
        <UIModalContent
          animation={animation}
          css={dynamicStyles}
          bg="primary"
          overflowY="scroll"
          maxWidth={props.maxWidth}
        >
          {showClose && actions ? (
            <Flex
              style={{
                position: "sticky",
                top: 0,
                zIndex: 99,
                background,
                width: "100%",
                paddingBottom: 5,
              }}
              justify="flex-end"
              height="30px"
              align="center"
            >
              {typeof actions !== "undefined" ? actions : null}
              <Close onClick={onClose} />
            </Flex>
          ) : null}
          {showClose && !actions ? <Close onClick={onClose} /> : null}
          {typeof title !== "undefined" ? (
            <ModalHeader css={modalHeaderStyles}>{title}</ModalHeader>
          ) : typeof titleSlot !== "undefined" ? (
            <ModalHeader style={{ paddingBottom: "0px" }} css={modalHeaderStyles}>
              {titleSlot}
            </ModalHeader>
          ) : null}
          <ModalBodyExtended
            css={`
              ${bodyStyle}
            `}
          >
            {content}
          </ModalBodyExtended>
          {typeof footer !== "undefined" ? (
            <ModalFooter
              css={`
                jusify-content: center;
              `}
            >
              {footer}
            </ModalFooter>
          ) : null}
        </UIModalContent>
      </Modal>
    </>
  );
};

export default WrewardsModal;

const Close = styled.div`
  --size: 14px;
  height: 30px !important;
  box-sizing: border-box;
  top: 6px;
  position: absolute;
  right: 12px;
  width: 30px !important;
  z-index: 9999;
  display: inline-block;
  width: var(--size);
  height: var(--size);
  background-image: url("/images/TheModalBox/close.svg");
  background-size: var(--size);
  background-repeat: no-repeat;
  background-position: center;
  background-clip: border-box;
  cursor: pointer;
`;

const UIModalContent = styled(ModalContent)`
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ModalBodyExtended = styled(ModalBody)`
  padding: 20px 24px !important;
  @media screen and (max-width: 500px) {
    padding: 20px 12px !important;
  }
`;
